'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styles from './categoryLinks.module.scss';

import { CATEGORY_IMAGE_MAP, CATEGORY_URL_MAP, LABEL_NORMALIZATION_MAP, } from '@/lib/constants/categoryMaps';

const CategoryLinks: React.FC = () => {

  const categories = Object.keys(CATEGORY_URL_MAP)
    .map(key => {
      const normalizedName = LABEL_NORMALIZATION_MAP[key.toLowerCase()] ?? key;
      const imageMeta = CATEGORY_IMAGE_MAP[normalizedName];

      return {
        name: normalizedName,
        href: `${CATEGORY_URL_MAP[normalizedName]}`,
        image: imageMeta?.src,
        width: imageMeta?.width,
        height: imageMeta?.height,
      };
    });

  if (categories.length === 0) return null;

  return (
    <>
      <h2 className={styles.mobileHeader}>Shop By Category</h2>
      <div className={styles.categories}>
        {categories.map((category, index) => (
          <div className={styles.category} key={index}>
            <Link href={category.href}>
              <div className={styles.imageWrapper}>
                <Image
                  src={category.image}
                  alt=''
                  width={category.width}
                  height={category.height}
                />
              </div>
              <div className={styles.categoryName}>{category.name}</div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default CategoryLinks;
